<template>
  <div>
    <button class="button" v-show="1">
      <span>测试</span>
    </button>
    <!-- 监控管理树 -->
    <MapModal
      :modalNode="modalNode"
      :title="bimVideoCategory.title"
      :id="bimVideoCategory.id"
      :close="videoSurveilClick"
    >
      <!-- <template slot="content"> ZHANG </template> -->
      <!-- <template slot="foot"> guan </template> -->
    </MapModal>
    <!-- 添加 编辑 类 -->
    <UpdateForm
      v-show="ifSort"
      :state="renewState"
      :close="renewClose"
      ref="zhang"
    ></UpdateForm>
    <!-- add/edit 监控管理树 -->
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const UpdateForm = () => import("./surveilDirectory/UpdateForm.vue");
// import { treeData, predefineColors } from "./static-data.js";
// import { UpdateForm } from "./surveilDirectory/UpdateForm.vue";
// import { EventBus } from "@/static/js/event-bus.js";
import { bimVideo } from "@/api/api";
export default {
  name: "video-surveil",
  components: { MapModal, UpdateForm },
  data() {
    return {
      // 假数据
      treeDataJson: [
        {
          id: 1,
          text: "一级 1",
          i_icon: "el-icon-folder-opened",
          children: [
            {
              id: 4,
              text: "测试标题",
              i_icon: "el-icon-jiankong",
              form: {
                // 自定义
                id: "0",
                name: "二级 1-1",
              },
              operate: [
                //操作按钮
                {
                  i_icon: "small-operation-btn el-icon-edit",
                  click: this.handleEdit,
                },
                {
                  i_icon: "small-operation-btn el-icon-delete",
                  click: this.handleDelete,
                },
              ],
              children: [
                {
                  id: 9,
                  i_icon: "el-icon-jiankong",
                  text: "三级 1-1-1",
                },
                {
                  id: 10,
                  text: "三级 1-1-2",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          text: "一级 2",
          children: [
            {
              id: 5,
              text: "二级 2-1",
              children: [
                {
                  id: 10,
                  text: "三级 2-1-1",
                },
              ],
            },
            {
              id: 6,
              text: "二级 2-2",
              // text: "我是一个超长文本",
            },
          ],
        },
        {
          id: 3,
          text: "一级 3",
          children: [
            {
              id: 7,
              text: "二级 3-1",
            },
            {
              id: 8,
              text: "二级 3-2",
            },
          ],
        },
      ],
      graphicLayer: [],

      bimVideoCategory: {
        title: "全局模态框",
        id: "bimVideoCategory", // id和ref使用的同一个
      },
      modalNode: {
        bimVideoCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -376,
            // unit: "px", // 默认px
          },
          // width: "450px", // 宽度配置 默认450px
          height: "350px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "bimVideoCategoryTree", // id和ref使用的同一个
            name: "text", // 树的展示字段 默认name
            i_icon: {
              level_1: "el-icon-star-off",
              level_2: "el-icon-s-goods",
              // level_3: "el-icon-video-pause",
            },
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            search: {
              //不需要搜索直接不传
              // type: "", //暂时无用 预留字段 后期配置 判断是否是ajax
              keywords: "text", // 搜素配置关键字 默认是name
              // filterNode: this.filterNode, // 搜索的逻辑 可以自己配置
            },
            // nodeClick 事件绑定
            nodeClick: this.nodeClick,
          },
          //模态框foot配置
          foot: {
            addCategory: {
              type: "button",
              buttonType: "primary",
              i_icon: "el-icon-zengjia",
              title: "表单",
              disabled: false,
              click: this.addCategory,
            },
          },
        },
      },
      ifSort: false,
      renewState: "add",
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    // 自定义方法
    toggleFold(item, state) {
      item.state = state;
    },
    filterNode(value, data, node) {
      console.log("搜素自己逻辑,以后会和ajax配合使用");
    },
    // 节点被点击时的回调
    nodeClick(data) {
      console.log("节点被点击时的回调");
      console.log(data);
    },
    videoSurveilClick() {
      console.log("老方法 触发关闭");
      console.log(this.$GLOBAL.markDrawGraphicLayer2);
      if (this.$GLOBAL.markDrawGraphicLayer) {
        this.$GLOBAL.markDrawGraphicLayer.clear();
      }

      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      this.$emit("videoSurveilBox_close");
    },
    // 编辑
    handleEdit(data, node) {
      console.log(data);
      console.log(node);
      // if(ref.currentNode)
      //    console.log(ref.currentNode.node);
      // console.log(this.$refs.zhang.submitData);
      this.renewState = "edit";
      this.ifSort = true;
      let { name } = data.form;
      this.$refs.zhang.submitData.parentId = "0";
      this.$refs.zhang.submitData.name = name;

      // this.$refs.zhang.submitData = data.id;
    },
    // 删除
    handleDelete(data) {
      console.log(data);
    },
    // 新增
    addCategory() {
      this.renewState = "add";
      // this.modalNode.bimVideoCategory.foot.addCategory.disabled = true;
      this.ifSort = true;
    },
    renewClose() {
      this.renewState = "add";
      this.ifSort = false;
    },
    unpackData(data) {
      console.log(data);
      data.forEach((item) => {
        console.log(item);
        item.children.forEach((i) => {
          console.log(i);
          i.operate = [
            //操作按钮
            {
              i_icon: "small-operation-btn el-icon-edit",
              click: this.handleEdit,
            },
            {
              i_icon: "small-operation-btn el-icon-delete",
              click: this.handleDelete,
            },
          ];
        });
      });
      // this.modalNode.bimVideoCategory.content.treeDataJson = data;
    },
    // 初始化
    init() {
      this.modalNode.bimVideoCategory.content.treeDataJson = this.treeDataJson;
      this.modalNode.bimVideoCategory.loading = false;
      let modelData = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
      };
      bimVideo(modelData)
        .then((res) => {
          // this.modalNode.bimVideoCategory.loading = false;
          this.unpackData(res.data.data);
        })
        .catch((res) => {
          that.$alert("网络不加，请求错误！！", "请刷新页面", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {},
          });
        });
      document.querySelector(".button").onmousemove = (e) => {
        const x = e.pageX - e.target.offsetLeft;
        const y = e.pageY - e.target.offsetTop;
        e.target.style.setProperty("--x", `${x}px`);
        e.target.style.setProperty("--y", `${y}px`);
      };
    },
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    this.init();
  },
  watch: {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.button {
  margin: 20px;
  width: 20em;
  position: absolute;
  top: 3em;
  left: 16em;
  appearance: none;
  // background: #f72359;
  background: #409eff;
  padding: 0.5em 1em;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  overflow: hidden;
  border-radius: 4px;
  span {
    position: relative;
  }
  &::before {
    --size: 0;
    content: "";
    position: absolute;
    left: var(--x);
    top: var(--y);
    width: var(--size);
    height: var(--size);
    // background: radial-gradient(circle closest-side, #4405f7, transparent);
    background: radial-gradient(circle closest-side, #ded2ff, transparent);
    transform: translate(-50%, -50%);
    transition: width 0.2s ease, height 0.2s ease;
  }
  &:hover::before {
    --size: 400px;
  }
}
</style>
